function initCollectionInfiniteScroll() {
  const grid = document.querySelector('#product-grid');
  const sentinel = document.querySelector('#CollectionInfiniteScrollSentinel');
  let nextLink = document.querySelector('#CollectionNextPage');

  if (!grid || !sentinel || !nextLink) {
    console.log('Infinite scroll: missing required elements');
    return;
  }

  if (document.body.dataset.collectionInfiniteScrollInit === 'true') return;
  document.body.dataset.collectionInfiniteScrollInit = 'true';

  let loading = false;

  function showLoader() {
    let loader = document.querySelector('.collection-infinite-scroll-loading');

    if (!loader) {
      loader = document.createElement('div');
      loader.className = 'collection-infinite-scroll-loading';
      loader.textContent = 'Loading more products...';
      sentinel.parentNode.insertBefore(loader, sentinel);
    }
  }

  function hideLoader() {
    const loader = document.querySelector('.collection-infinite-scroll-loading');
    if (loader) loader.remove();
  }

  async function loadNextPage() {
    if (loading || !nextLink) return;

    loading = true;
    showLoader();

    console.log('Infinite scroll: fetching', nextLink.href);

    try {
      const response = await fetch(nextLink.href, {
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#product-grid');
      const newNextLink = doc.querySelector('#CollectionNextPage');

      if (!newGrid) {
        throw new Error('No #product-grid found in fetched page');
      }

      const newItems = newGrid.querySelectorAll('.grid__item');

      if (!newItems.length) {
        cleanup();
        return;
      }

      const fragment = document.createDocumentFragment();
      newItems.forEach((item) => fragment.appendChild(item));
      grid.appendChild(fragment);

      if (newNextLink) {
        nextLink.href = newNextLink.href;
      } else {
        cleanup();
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
    } finally {
      loading = false;
      hideLoader();
    }
  }

  function cleanup() {
    window.removeEventListener('scroll', onScroll);
    if (sentinel) sentinel.remove();
    if (nextLink) nextLink.remove();
    nextLink = null;
  }

  function onScroll() {
    if (!nextLink || loading) return;

    const triggerPoint = window.innerHeight + window.scrollY;
    const pageBottom = document.documentElement.scrollHeight - 800;

    if (triggerPoint >= pageBottom) {
      loadNextPage();
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  console.log('Infinite scroll: initialized');
}

document.addEventListener('DOMContentLoaded', initCollectionInfiniteScroll);
document.addEventListener('shopify:section:load', () => {
  document.body.dataset.collectionInfiniteScrollInit = 'false';
  initCollectionInfiniteScroll();
});